import { useNavigate } from "react-router-dom";

import Button from "components/Button";
import HomePageFooter from "components/HomePageFooter";

import "./style.scss";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <div className="home-main">
        <h1 className="home-title">
          Welcome to ThermalPoint
        </h1>
        <p className='home-subtext'>
          Estimate Average Home Heat Loss and Assess Heat Pump Sizing Using Historical Natural Gas Consumption Data
        </p>
        <Button onClick={() => navigate("/calculator")}>Start</Button>
      </div>
      <HomePageFooter />
    </div>
  );
};

export default Home;
